export const engagingHeroImages = {
  default: {
    mobile: '/VRMLookupWithVideo/Mobile_DefaultImage_esfsyc.jpg',
    tablet: '/VRMLookupWithVideo/Tablet_DefaultImage_b8qcar.jpg',
    desktop: '/VRMLookupWithVideo/Desktop_DefaultImage_fnbewt.jpg',
  },
  'air-conditioning-regas': {
    mobile: '/VRMLookupWithVideo/Mobile_AirConditioningRegas_gdehqy.jpg',
    tablet: '/VRMLookupWithVideo/Tablet_AirConditioningRegas_sqhj9i.jpg',
    desktop: '/VRMLookupWithVideo/Desktop_AirConditioningRegas_o8ufee.jpg',
  },
  'alternator-replacement': {
    mobile: '/VRMLookupWithVideo/Mobile_AlternatorReplacement_zqsknu.jpg',
    tablet: '/VRMLookupWithVideo/Tablet_AlternatorReplacement_wxqwbx.jpg',
    desktop: '/VRMLookupWithVideo/Desktop_AlternatorReplacement_ywemka.jpg',
  },
  'brake-discs-pads-replacement': {
    mobile: '/VRMLookupWithVideo/Mobile_BrakeDiscsPadsReplacement_lb4njf.jpg',
    tablet: '/VRMLookupWithVideo/Tablet_BrakeDiscsPadsReplacement_j8t7tq.jpg',
    desktop: '/VRMLookupWithVideo/Desktop_BrakeDiscsPadsReplacement_pn6uku.jpg',
  },
  'brake-pads-replacement': {
    mobile: '/VRMLookupWithVideo/Mobile_BrakePadsReplacement_b2zam2.jpg',
    tablet: '/VRMLookupWithVideo/Tablet_BrakePadsReplacement_mg7nkn.jpg',
    desktop: '/VRMLookupWithVideo/Desktop_BrakePadsReplacement_i0rsnp.jpg',
  },
  'car-diagnostic': {
    mobile: '/VRMLookupWithVideo/Mobile_CarDiagnostic_afgviz.jpg',
    tablet: '/VRMLookupWithVideo/Tablet_CarDiagnostic_pliyui.jpg',
    desktop: '/VRMLookupWithVideo/Desktop_CarDiagnostic_ssypdj.jpg',
  },
  'car-service': {
    mobile: '/VRMLookupWithVideo/Mobile_CarService_obqwho.jpg',
    tablet: '/VRMLookupWithVideo/Tablet_CarService_tuwde1.jpg',
    desktop: '/VRMLookupWithVideo/Desktop_CarService_hpmsja.jpg',
  },
  'timing-belt-replacement': {
    mobile: '/VRMLookupWithVideo/Mobile_TimingBeltReplacement_pvimps.jpg',
    tablet: '/VRMLookupWithVideo/Tablet_TimingBeltReplacement_jhpavj.jpg',
    desktop: '/VRMLookupWithVideo/Desktop_TimingBeltReplacement_qnomsf.jpg',
  },
} as Record<string, Record<'mobile' | 'tablet' | 'desktop', string>>;
